import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import NewsCategory from "@/pages/category/news/page";
import DramaCategory from "@/pages/category/drama/page";
import NewsDetail from "@/pages/detail/news/page";
import DramaDetail from "@/pages/detail/drama/page";
import Specials from "@/pages/specials/page";
import About from "@/pages/about/page";
import SearchPage from "@/pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/news", element: <NewsCategory /> },
      { path: "/category/drama", element: <DramaCategory /> },
      { path: "/detail/news/:id", element: <NewsDetail /> },
      { path: "/detail/drama/:id", element: <DramaDetail /> },
      { path: "/specials", element: <Specials /> },
      { path: "/about", element: <About /> },
      { path: "/search", element: <SearchPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;